import React from "react";
import cx from "classnames";

export function ModalBody(props: { children: React.ReactNode, className?: string, style?: React.CSSProperties }) {
    return (<div className={cx("p-4", props.className,)}
                 style={props.style}>
        {props.children}
    </div>);
}